import { createSelector } from '@ngrx/store';

import { locationsImagesState } from '../root';

export const getAllLocationImages = createSelector(locationsImagesState, (locationsImages) => locationsImages);
